// src/components/courses/CoursesSection.jsx
import React from 'react';
import CourseCard from './CourseCard';
import coursesData from '../../data/db.json'; // Assuming db.json is in src/data

const CoursesSection = () => {
  const courses = coursesData.courses;

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800 font-heading">Our Popular Courses</h2>
        <p className="text-lg text-gray-600 mt-2">Explore our high-yielding courses designed for your success.</p>
      </div>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {courses.map((course, index) => (
          <CourseCard key={index} course={course} />
        ))}
      </div>
    </section>
  );
};

export default CoursesSection;